import hekateBus from '../../bus';

type WaPushEventName =
  | 'FormErrorAdded'
  | 'FormFieldErrorAdded'
  | 'PostSentryError'
  | 'MouseflowPush'
  | 'ErrorSoft422'
  | 'ErrorHard422'
  | 'UnSupportSubmitError'
  | 'ErrorRecaptchaNotLoaded';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export default class WaUtil {
  public static waPush({
    event,
    data,
  }: {
    event: WaPushEventName;
    data: Record<string, string | number | boolean | Array<string | number | boolean>>;
  }) {
    hekateBus.dispatchEvent('wa-push', {
      event,
      data,
    });
  }
}
